import { Box } from '@mui/material';
import { Input } from '../../../../../shared/components/Input';
import {
  formatCurrency,
  formatDateTime,
} from '../../../../../shared/utils/helpers/numbers';
import Divider from '@mui/material/Divider';
import ComponentTable from '../../../../Components/Table/Index';
import { Column } from '../../../../Components/Table/Types';
import { TabPanel } from '@mui/lab';

interface CadastroProps {
  nfPreView: any;
}

export const TabCadastro = ({ nfPreView }: CadastroProps) => {
  const columns: Column[] = [
    { id: 'nfeIt_proId', label: 'Produto', align: 'center', width: 50 },
    { id: 'nfeIt_xProd', label: 'Descrição do Produto', minWidth: 0 },
    { id: 'nfeIt_cfopId', label: 'CFOP', minWidth: 0 },
    { id: 'nfeIt_quantidade', label: 'Qtd.', minWidth: 0 },
    { id: 'nfeIt_valUnit', label: 'V. Unitário', minWidth: 0 },
    { id: 'nfeIt_baseIcmsXML', label: 'Base ICMS', minWidth: 0 },
    { id: 'nfeIt_valorIcmsXML', label: 'Valor ICMS', minWidth: 0 },
    { id: 'nfeIt_baseSt', label: 'Base ST', minWidth: 0 },
    { id: 'nfeIt_valorSt', label: 'Valor ST', minWidth: 0 },
    { id: 'nfeIt_valorTotalProduto', label: 'Valor Total', minWidth: 0 },
  ];

  const rows = nfPreView?.produtos
    ? nfPreView.produtos.map((item: any) => {
        return {
          nfeIt_proId: item.nfeIt_proId,
          nfeIt_xProd: item.nfeIt_xProd,
          nfeIt_cfopId: item.nfeIt_cfopId,
          nfeIt_quantidade: item.nfeIt_quantidade,
          nfeIt_valUnit: formatCurrency(item?.nfeIt_valUnit ?? 0, 2, 2),
          nfeIt_baseIcmsXML: formatCurrency(item?.nfeIt_baseIcmsXML ?? 0, 2, 2),
          nfeIt_valorIcmsXML: formatCurrency(
            item?.nfeIt_valorIcmsXML ?? 0,
            2,
            2
          ),
          nfeIt_baseSt: formatCurrency(item?.nfeIt_baseSt ?? 0, 2, 2),
          nfeIt_valorSt: formatCurrency(item?.nfeIt_valorSt ?? 0, 2, 2),
          nfeIt_valorTotalProduto: formatCurrency(
            item?.nfeIt_valorTotalProduto ?? 0,
            2,
            2
          ),
        };
      })
    : [];

  return (
    <TabPanel value='1'>
      <Box className='grid grid-cols-8 gap-3 h-full'>
        <Input
          disabled={true}
          label='ID'
          className='col-span-1'
          name='ID'
          value={nfPreView.nfe_id}
        />
        <Input
          disabled={true}
          label='N. NF'
          className='col-span-2'
          name='ID'
          value={nfPreView?.nfe_numeroNf}
        />
        <Input
          disabled={true}
          label='Data de Emissão'
          className='col-span-2'
          name='ID'
          value={formatDateTime(nfPreView?.nfe_dataEmissao)}
        />
        <Input
          disabled={true}
          label='Inclusão'
          className='col-span-2'
          name='ID'
          value={formatDateTime(nfPreView.nfe_dataInc)}
        />
        <Input
          disabled={true}
          label='Cidade'
          className='col-span-2'
          name='ID'
          value={nfPreView.cli_cidade}
        />
        <Input
          disabled={true}
          label='UF'
          className='col-span-1'
          name='ID'
          value={nfPreView?.cli_uf}
        />

        <Input
          disabled={true}
          label='Saída'
          className='col-span-2'
          name='ID'
          value={formatDateTime(nfPreView?.nfe_dataSaida ?? '')}
        />
        <Box className={'col-span-2'} />
        <Input
          disabled={true}
          label='Fornecedor'
          className='col-span-3'
          name='ID'
          value={nfPreView?.cli_nome}
        />
        <Input
          disabled={true}
          label='Tel'
          className='col-span-2'
          name='ID'
          value={nfPreView?.cli_telefone}
        />
        <Divider className={'col-span-8'} />
        <Input
          disabled={true}
          label='Ser. NF'
          className='col-span-1'
          name='ID'
          value={nfPreView.nfe_ser}
        />
        <Input
          disabled={true}
          label='Mod NF'
          className='col-span-1'
          name='ID'
          value={nfPreView?.nfe_mod}
        />
        <Input
          disabled={true}
          label='B. ST'
          className='col-span-1'
          name='ID'
          value={nfPreView?.nfe_stBase}
        />
        <Box className={'col-span-5'} />
        <Input
          disabled={true}
          label='B. ICMS'
          className='col-span-1'
          name='ID'
          value={formatCurrency(nfPreView?.nfe_icmsBase ?? 0, 2, 2)}
        />
        <Input
          disabled={true}
          label='Valor Total ICMS'
          className='col-span-2'
          name='ID'
          value={formatCurrency(nfPreView?.nfe_totalIcms ?? 0, 2, 2)}
        />
        <Input
          disabled={true}
          label='IPI Base'
          className='col-span-1'
          name='ID'
          value={formatCurrency(nfPreView?.nfe_ipiBase ?? 0, 2, 2)}
        />
        <Input
          disabled={true}
          label='Valor Total IPI'
          className='col-span-2'
          name='ID'
          value={formatCurrency(nfPreView?.nfe_totalIpi ?? 0, 2, 2)}
        />
        <Box className={'col-span-1'} />
        <Input
          disabled={true}
          label='Valor Frete'
          className='col-span-2'
          name='ID'
          value={formatCurrency(nfPreView?.nfe_valorFrete ?? 0, 2, 2)}
        />
        <Input
          disabled={true}
          label='Valor Total Produtos'
          className='col-span-2'
          name='ID'
          value={formatCurrency(nfPreView?.nfe_totalProdutos ?? 0, 2, 2)}
        />
        <Input
          disabled={true}
          label='Valor Total NF'
          className='col-span-2'
          name='ID'
          value={formatCurrency(nfPreView?.nfe_valorTotalNf ?? 0, 2, 2)}
        />
        <Box className={'col-span-8'}>
          <ComponentTable columns={columns} rows={rows} tableHeight={'25vh'} />
        </Box>
      </Box>
    </TabPanel>
  );
};